import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { motion } from 'framer-motion';
import { EmpreenderApps } from '../lib/AppsArray';
import { useUser } from '../UserContext';

interface ToggleMenuBoxProps {
	isOpen: boolean;
	app: string;
}


const searchApps = (keyword: string) => {
	const normalize = (text: string) =>
		text
			?.toLowerCase()
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.replace(/\s+/g, "");

	return EmpreenderApps.filter((app) =>
		normalize(app.name).includes(normalize(keyword)) ||
		app.tags.some((tag) => normalize(tag).includes(normalize(keyword)))
	);
};

const ToggleMenuBox = ({ isOpen, app }: ToggleMenuBoxProps) => {
	const selectedApp = searchApps(app);

	const { hideApps } = useUser();

	return (
		<div className="w-[230px] h-9 bg-white flex items-center py-1.5 px-3 rounded-lg gap-3 hover:bg-gray-100 transition select-none">
			<div className="text-gray-900">{selectedApp[0]?.icon}</div>
			<div className="flex flex-row w-full items-center justify-between !m-0">
				<span className="text-gray-900 font-semibold text-[15px]">{app}</span>

				{
					!hideApps ? <motion.div className="flex size-3 shrink-0 origin-center items-center justify-center text-gray-500" animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.25, ease: [0, 0.71, 0.2, 1.01] }}>
						<ChevronDownIcon className="size-full stroke-[2.5px]" />
					</motion.div> : <></>
				}

			</div>
		</div>
	);
};

export default ToggleMenuBox;
